import { render, staticRenderFns } from "./BookSitesTab.html?vue&type=template&id=01751bde&scoped=true&"
import script from "./BookSitesTab.ts?vue&type=script&lang=ts&"
export * from "./BookSitesTab.ts?vue&type=script&lang=ts&"
import style0 from "./BookSitesTab.scss?vue&type=style&index=0&id=01751bde&scoped=true&lang=scss&"
import style1 from "./BookSitesTab.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01751bde",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VImg,VRow})
